import React, {Component} from "react";
import Tabs from 'react-bootstrap/Tabs';
import toastr from "toastr";
import App from "../../App";
import AccountService from "../../services/account-service";
import ToastOptions from "../../common/toast/toastr-config.js";
import Loading from "../../common/Loading/Loading";
import HistoryBackLink from "../../common/BackLink/HistoryBackLink";
import AccountHeader from "./components/AccountHeader";
import AccountProducts from "./components/AccountProducts";
import CreateDialog from "../../common/CreateDialog/CreateDialog";
import "./AccountDetails.css";
import ActivationButton from "../../common/ActivationButton/ActivationButton";
import Tab from "react-bootstrap/Tab";
import Attributes from "../account-details/components/Attributes";
import Permissions from "../../authentication/Permissions"
import AuthorizationService from "../../services/authorization-service";

class AccountDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      account: {
        name: "",
        customerId: "",
        isActive: true,
        createdAt: "",
        updatedAt: "",
        subscriptions: [],
        attributes: [],
        contact: {
          firstName: "",
          lastName: "",
          email: ""
        }
      },
      loading: true,
      attributeChange: false,
      isSaving: false,
      isDeactivateAccountModalVisible: false,
      isEditAccountModalVisible: false,
      newAccountName: "",
      newAccountCustomerId: "",
      invalidFields: {
        name: {
          invalid: false,
          message: ""
        },
        customerId: {
          invalid: false,
          message: ""
        }
      },
      isDialogLoading: false
    };
  }

  componentWillMount() {
    this.fetchAccount();
  }

  fetchAccount = async () => {
    try {
      const accountId = this.props.match.params.id;
      const account = await AccountService.getAccountById(accountId);
      this.initializeStates(account.data);
    } catch (error) {
      toastr.options = ToastOptions;
      toastr.error(error.message);
    }
  };

  initializeStates = data => {
    this.setState({
      loading: false,
      isSaving: false,
      account: data,
      newAccountName: data.name,
      newAccountCustomerId: data.customerId
    });
  };

  handleEditAccountDialogToggle = () => {
    if (!this.state.isEditAccountModalVisible) {
      this.setState({
        isEditAccountModalVisible: !this.state.isEditAccountModalVisible
      });
    } else if (this.state.isEditAccountModalVisible) {
      this.resetState();
    }
  };

  resetState = () => {
    this.setState({
      isEditAccountModalVisible: false,
      newAccountName: this.state.account.name,
      newAccountCustomerId: this.state.account.customerId,
      attributeChange: false,
      isSaving: false,
      invalidFields: {
        name: {
          invalid: false,
          message: ""
        },
        customerId: {
          invalid: false,
          message: ""
        }
      }
    });
  };

  validateName = e => {
    let newName = e.target.value.trim();
    let isNameInvalid = this.state.invalidFields.name.invalid;
    let message = this.state.invalidFields.name.message;
    if (newName === "") {
      isNameInvalid = true;
      message = "Required field";
    } else if (!/^([0-9a-zA-Z \\$.%_-]*)$/.test(newName)) {
      isNameInvalid = true;
      message =
          "Name must contains only letters, numbers and special characters: ._\\-$ %";
    } else {
      isNameInvalid = false;
      message = "";
    }

    this.setState({
      invalidFields: {
        ...this.state.invalidFields,
        name: {
          invalid: isNameInvalid,
          message: message
        }
      },
      newAccountName: e.target.value
    });
  };

  validateCustomerId = e => {
    let newCustomerId = e.target.value;
    let isCustomerInvalid = this.state.invalidFields.customerId.invalid;
    let message = this.state.invalidFields.customerId.message;
    if (!/^([A-Za-z0-9]{0,64})$/.test(newCustomerId)) {
      isCustomerInvalid = true;
      message = "Must not contain space or special symbols.";
    } else {
      isCustomerInvalid = false;
      message = "";
    }

    this.setState({
      invalidFields: {
        ...this.state.invalidFields,
        customerId: {
          invalid: isCustomerInvalid,
          message: message
        }
      },
      newAccountCustomerId: e.target.value
    });
  };

  handleAttributeChange = event => {
    let account = {...this.state.account}
    if (!account.attributes) account.attributes = [];
    if (account.attributes.find(a => a.name === event.target.id)) {
      account.attributes = account.attributes.map(at => {
        if (at.name === event.target.id) {
          at.value = event.target.value;
        }
        return at;
      });
    } else {
      account.attributes.push({name: event.target.id, value: event.target.value});
    }
    this.setState({
      account: account,
      attributeChange: true
    });

  }

  handleErrors = error => {
    let errorData = error.response.data;
    let statusCode = errorData.statusCode;
    let name = errorData.name;
    console.log(error);

    if (name === "Validation Error") {
      let newState = this.state.invalidFields;
      if (statusCode === 400) {
        let body = errorData.body;
        body.forEach(fieldError => {
          let field = fieldError.field;
          let message = fieldError.message;

          if (field === "name") {
            newState.name.invalid = true;
            newState.name.message = message;
          }

          if (field === "customerId") {
            newState.customerId.invalid = true;
            newState.customerId.message = message;
          }
        });
      }
      this.setState({invalidFields: newState});
      toastr.options = ToastOptions;
      toastr.error(`${errorData.message}`);
    } else {
      toastr.options = ToastOptions;
      toastr.error(error.message);
    }
  };

  saveSubscription = async (accountId, sub) => {
    this.setState({isDialogLoading: true, isSaving: true});
    const response = await AccountService.saveSubscription(accountId, sub);
    this.setState({
      sub: response.data,
      isDialogLoading: false,
      isSaving: false
    });
    return response;
  }

  /**
   * Update the account.  This is passed into many children in order to be called in order to call the account update API.
   * Accepts the account to be saved - this should be the modified version of the account.
   */
  updateAccount = async account => {
    try {
      this.setState({isDialogLoading: true, isSaving: true});
      toastr.success("Starting account update. You will be notified when complete.  Large accounts may take a few minutes.");
      //Trigger UI refresh before save
      this.setState({
        account: account
      })
      //If we change global attributes we need to resync all subs with APIGee
      if (this.state.attributeChange) {
        account.subscriptions.forEach(sub => {
              sub.isApiGeeSynced = false
            }
        )
      }
      const response = await AccountService.updateAccount(account);
      toastr.options = ToastOptions;
      toastr.success("The account has been updated.");
      this.setState({
        account: response.data,
        isSaving: false,
        isDialogLoading: false
      });
    } catch (error) {
      this.setState({isDialogLoading: false, isSaving: false});
      this.handleErrors(error);
    }
  }

  editAccount = async () => {
    try {
      await this.updateAccount(this.state.account);
      toastr.options = ToastOptions;
      toastr.success("The account has been updated.");
      this.handleEditAccountDialogToggle();
    } catch (error) {
      this.setState({ isDialogLoading: false });
      this.handleErrors(error);
    }
  };

  // Deactivate Account
    changeAccountActiveStatus = async (account) => {
        try {
          this.setState({isDialogLoading: true});
          this.state.account.isActive = !this.state.account.isActive
          //Iterate through all subscriptions and deactivate or reactivate
          if (this.state.account.subscriptions) {
            this.state.account.subscriptions.forEach(sub => {
              //Check to see if we are changing the status for a sub.  If so, than flip the status and mark for APIGee sync
              if (sub.isActive !== this.state.account.isActive) {
                sub.isApiGeeSynced = false;
                sub.isActive = this.state.account.isActive;
              }
            })
          }
          const response = await AccountService.updateAccount(this.state.account);
          this.setState({
            account: response.data,
            isDeactivateAccountModalVisible: false,
            isDialogLoading: false
          });
          this.fetchAccount();
          toastr.options = ToastOptions;
          toastr.success(
              response.data.isActive
              ? "The account has been activated."
          : "The account has been deactivated."
      );
    } catch (error) {
      this.setState({ isDialogLoading: false });
      this.handleErrors(error);
    }
  };


  render() {
    return (
      <App {...this.props}>
        {this.state.loading && <Loading className="account-loading" />}
        <HistoryBackLink directionName={"Accounts"} />
        <div className="account-details">
          <div className="account-title">
            <span className="name">{this.state.account.name}</span>
            <div className="actions">
              {AuthorizationService.hasPermission(Permissions.account.changeStatus) &&
              <ActivationButton
                  item={this.state.account}
                  isActive={this.state.account.isActive}
                  header="account"
                  description={`account with name: ${this.state.account.name} ? The related subscriptions will be affected. OM integrated subscription will not be affected`}
                  toggleFunction={this.changeAccountActiveStatus}
              />
              }
            </div>
          </div>

          <AccountHeader
              account={this.state.account}
              updateAccount={this.updateAccount}
              isSaving={this.state.isSaving}
          />

          <Tabs defaultActiveKey="products" id="uncontrolled-tab-example">
            <Tab eventKey="products" title="Products">
              <AccountProducts
                  account={this.state.account}
                  updateAccount={this.updateAccount}
                  saveSubscription={this.saveSubscription}
              />
            </Tab>
            <Tab eventKey="defAttributes" title="Default Attributes">
              <Attributes
                  account={this.state.account}
                  handleAttributeChange={this.handleAttributeChange}
                  updateAccount={this.updateAccount}
                  isSaving={this.state.isSaving}
              />
            </Tab>
          </Tabs>


          {/* Edit account */}
          <CreateDialog
              isModalVisible={this.state.isEditAccountModalVisible}
              isDialogLoading={this.state.isDialogLoading}
              handleDialogToggle={this.handleEditAccountDialogToggle}
              action={this.editAccount}
              modalHeaderName="Edit Account"
              modalBodyFields={[
              {
                label: "Name",
                id: "name",
                inputType: "text",
                onChange: this.validateName,
                validateFieldName: "",
                isFieldInvalid: this.state.invalidFields.name.invalid,
                invalidFieldMessage: this.state.invalidFields.name.message,
                newField: this.state.newAccountName,
                defaultValue: this.state.newAccountName
              },
              {
                label: "Customer ID",
                id: "customerId",
                inputType: "text",
                onChange: this.validateCustomerId,
                validateFieldName: "",
                isFieldInvalid: this.state.invalidFields.customerId.invalid,
                invalidFieldMessage: this.state.invalidFields.customerId.message,
                newField: this.state.newAccountCustomerId,
                defaultValue: this.state.newAccountCustomerId,
                maxLength: "64",
                fieldClassName: "name-container"
              }
            ]}
          />
        </div>
      </App>
    );
  }
}

export default AccountDetails;



// WEBPACK FOOTER //
// ./src/accounts/account-details/AccountDetails.js